import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import AiChat from '.';
import AgentTokens from './AgentTokens';
import AgentQueryLog from './AgentQueryLog';
import AiTokenUsage from './AiTokenUsage';

const AiChatRoutes: React.FC = () => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${match.path}/agent-tokens`} component={AgentTokens} />
      <Route exact path={`${match.path}/agent-query-log`} component={AgentQueryLog} />
      <Route exact path={`${match.path}/ai-token-usage`} component={AiTokenUsage} />
      <Route exact path={`${match.path}`} component={AiChat} />
    </Switch>
  );
};

export default AiChatRoutes;
